import ConceptLocker from './ConceptLocker';
import './ConceptLocker.scss';

export default ConceptLocker;